import dayjs from 'dayjs'

// 复用单站策略控制的图表与转换等纯工具（图表风格保持一致），但策略编辑组件本模块单独实现
export {
  createOption,
  getChartOption,
  transformJSON,
  strategyData2CamelCase,
  strategyData2UnderscoreCase,
  timeToMinutes,
  checkStrategyValidate,
  checkStrategyListValidate,
  isTimeSlotValid,
  minutesOfDay,
  STRATEGY_MODE_OPTIONS,
  getThresholdPlaceholder,
  cloneDeep,
  checkPermi,
} from '@/views/station-monitor/detail/tabs/StrategyController/utils.js'

/**
 * 从一套策略序列生成简短摘要，如「2充2放」
 * @param {Array} strategys
 */
export function summarizeStrategy(strategys = []) {
  let charge = 0
  let discharge = 0
  for (const s of strategys) {
    const power = Number(s.power)
    if (power > 0) charge++
    else if (power < 0) discharge++
  }
  return `${charge}充${discharge}放`
}

/**
 * 生成模板卡片摘要标签，如「工作日2充2放」
 */
export function templateSummaryTag(template = {}) {
  return `工作日${summarizeStrategy(template.strategys_work || [])}`
}

/** 模板库最大数量 */
export const MAX_TEMPLATES = 15

/** 模板名称最大长度（与编辑框 maxlength 保持一致） */
export const MAX_TEMPLATE_NAME_LEN = 30

/**
 * 生成副本名称：在原名后累加数字，避免与已有名称重复，且不超过长度上限
 * @param {string} name 原模板名称
 * @param {string[]} existNames 已存在的模板名称列表
 */
export function copyTemplateName(name = '', existNames = []) {
  const exist = new Set(existNames)
  // 去掉原名末尾已有的数字，取基础名
  const base = String(name).replace(/\d+$/, '') || String(name)
  // 拼接数字后缀时，先截断基础名为后缀预留空间，保证结果不超长且每个 i 都能产生不同名称
  // （若直接截断整串，基础名已达上限时后缀会被裁掉，导致候选名恒定不变而陷入死循环）
  const build = (n) => {
    const suffix = String(n)
    const maxBase = Math.max(0, MAX_TEMPLATE_NAME_LEN - suffix.length)
    return `${base.slice(0, maxBase)}${suffix}`
  }
  let i = 1
  let candidate = build(i)
  while (exist.has(candidate)) {
    i += 1
    candidate = build(i)
  }
  return candidate
}

/** 生成本地时间字符串 */
export function nowStr() {
  return dayjs().format('YYYY-MM-DD HH:mm:ss')
}
